import React from 'react';
import { Container, Typography, Box, Divider } from '@mui/material';

const Section = ({ title, children }) => (
  <Box sx={{ mb: 4 }}>
    <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>{title}</Typography>
    {children}
  </Box>
);

const Terms = () => (
  <Container maxWidth="md" sx={{ py: 6 }}>
    <Typography variant="h4" component="h1" gutterBottom>Terms of Service</Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
      Last updated: June 2026
    </Typography>
    <Divider sx={{ mb: 4 }} />

    <Section title="About KBros Leather">
      <Typography variant="body1">
        KBros Leather sells handcrafted leather goods made to order in the United States. By
        using this website or placing an order, you agree to these terms.
      </Typography>
    </Section>

    <Section title="Made-to-order products">
      <Typography variant="body1">
        Most items are made to order after purchase. Production times vary by product and are
        shown on each product page. We will notify you by email when your order ships. We do
        not guarantee specific delivery dates.
      </Typography>
    </Section>

    <Section title="Personalization and customization">
      <Typography variant="body1">
        Personalized or custom items (engraved text, custom dimensions, etc.) cannot be
        returned or exchanged unless there is a defect or error on our part. Please double-check
        all personalization details before placing your order.
      </Typography>
    </Section>

    <Section title="Returns and exchanges">
      <Typography variant="body1" paragraph>
        We accept returns on non-personalized items within 14 days of delivery, provided the
        item is unused and in original condition. To initiate a return, email us at{' '}
        <a href="mailto:info@kbrosleather.com">info@kbrosleather.com</a>.
      </Typography>
      <Typography variant="body1">
        Shipping costs for returns are the responsibility of the buyer unless the item arrived
        defective or was sent in error. Refunds are issued to the original payment method
        within 5–10 business days of receiving the return.
      </Typography>
    </Section>

    <Section title="Payments">
      <Typography variant="body1">
        Payments are processed securely by Stripe. All prices are in US dollars. Sales tax is
        calculated at checkout based on your shipping address. By placing an order you authorize
        the charge to your payment method for the total shown at checkout.
      </Typography>
    </Section>

    <Section title="Shipping">
      <Typography variant="body1">
        We ship within the United States. Shipping costs and estimated transit times are shown
        at checkout. Once an order leaves our shop, transit times are controlled by the carrier
        and we cannot guarantee delivery dates.
      </Typography>
    </Section>

    <Section title="Accounts">
      <Typography variant="body1">
        You are responsible for keeping your account credentials secure. You may delete your
        account at any time by contacting us. We reserve the right to suspend accounts that
        violate these terms.
      </Typography>
    </Section>

    <Section title="Intellectual property">
      <Typography variant="body1">
        All photos, designs, and content on this site are owned by KBros Leather. You may not
        reproduce or use them without written permission.
      </Typography>
    </Section>

    <Section title="Limitation of liability">
      <Typography variant="body1">
        KBros Leather is not liable for indirect, incidental, or consequential damages arising
        from the use of our products or website. Our liability is limited to the purchase price
        of the item in question.
      </Typography>
    </Section>

    <Section title="Changes to these terms">
      <Typography variant="body1">
        We may update these terms from time to time. Continued use of the site after changes
        are posted constitutes acceptance of the revised terms.
      </Typography>
    </Section>

    <Section title="Contact">
      <Typography variant="body1">
        Questions? Email{' '}
        <a href="mailto:info@kbrosleather.com">info@kbrosleather.com</a>.
      </Typography>
    </Section>
  </Container>
);

export default Terms;
